// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__hhDXY","MenuItem":"Menu_MenuItem__Vzf90","Active":"Menu_Active__LJ63a","Marker":"Menu_Marker__IAOF4"};